export type MixProduct = {
  id: string;
  title: string;
  creator: string;
  genre: string;
  subGenre?: string;
  bpmLabel: string;
  durationMinutes: number;
  releaseDate: string;
  priceCents: number;
  previewUrl?: string;
  artworkUrl?: string;
  isActive: boolean;
};

export const mixProducts: MixProduct[] = [
  {
    id: 'mix_80s_hits_15',
    title: '80s Hits Mix',
    creator: 'DJ PrimeTime',
    genre: 'Open Format',
    subGenre: '80s Classics',
    bpmLabel: '95-124 BPM',
    durationMinutes: 15,
    releaseDate: '2026-05-01',
    priceCents: 599,
    previewUrl: '/img/redloop1.mp4',
    artworkUrl: '/img/logo-primetime.png',
    isActive: true
  },
  {
    id: 'mix_rancheras_banda_30',
    title: 'Rancheras Con Banda Mix',
    creator: 'DJ Jordan',
    genre: 'Regional Mexicano',
    subGenre: 'Banda / Rancheras',
    bpmLabel: '88-112 BPM',
    durationMinutes: 30,
    releaseDate: '2026-04-25',
    priceCents: 999,
    previewUrl: '/img/redloopfornow.mp4',
    artworkUrl: '/img/primetimelogo1.png',
    isActive: true
  },
  {
    id: 'mix_cumbia_party_60',
    title: 'Cumbia Party Mix',
    creator: 'PrimeTime DJs',
    genre: 'Cumbia',
    subGenre: 'Party',
    bpmLabel: '92-104 BPM',
    durationMinutes: 60,
    releaseDate: '2026-04-18',
    priceCents: 1999,
    previewUrl: '/img/reddjvideolloop.mp4',
    artworkUrl: '/img/logo-primetime2.png',
    isActive: true
  },
  {
    id: 'mix_reggaeton_warmup_15',
    title: 'Reggaeton Warmup Mix',
    creator: 'DJ PrimeTime',
    genre: 'Reggaeton',
    subGenre: 'Warmup',
    bpmLabel: '88-96 BPM',
    durationMinutes: 15,
    releaseDate: '2026-04-12',
    priceCents: 599,
    previewUrl: '/img/redloop1.mp4',
    artworkUrl: '/img/primetimehomepage.png',
    isActive: true
  },
  {
    id: 'mix_restroom_break_30',
    title: 'Restroom Break Mix',
    creator: 'DJ Jordan',
    genre: 'Open Format',
    subGenre: 'Utility',
    bpmLabel: '100-128 BPM',
    durationMinutes: 30,
    releaseDate: '2026-04-08',
    priceCents: 999,
    artworkUrl: '/img/logo-primetimehomepage.png',
    isActive: true
  },
  {
    id: 'mix_cocktail_hour_60',
    title: 'Cocktail Hour Mix',
    creator: 'PrimeTime DJs',
    genre: 'Lounge',
    subGenre: 'Cocktail / Dinner',
    bpmLabel: '72-102 BPM',
    durationMinutes: 60,
    releaseDate: '2026-03-30',
    priceCents: 1999,
    previewUrl: '/img/redloopfornow.mp4',
    artworkUrl: '/img/primetimelogo1.png',
    isActive: true
  }
];
